import { Component, Input, ViewEncapsulation } from '@angular/core';
import { User } from '../../models/user';

@Component({
  selector: 'app-print-multiple-receipts',
  templateUrl: './print-multiple-receipts.component.html',
  styleUrls: ['./print-multiple-receipts.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class PrintMultipleReceiptsComponent {
  @Input() public bulkReceipts: any;
  @Input() public companyLogo: string;
  @Input() public user: User;
  @Input() public selectedCustomer: any;
  @Input() public hideStatusCodes: boolean;
  @Input() public hideParcelInfo: boolean;
  @Input() public hideRating: boolean;
  @Input() public hideSignature: boolean;
  @Input() public hideDestinationAddress: boolean;
  @Input() public hideOriginAddress: boolean;
  @Input() public hideLogo: boolean; // FR-004, FR-005, FR-009: Control logo visibility in bulk receipts
  @Input() public hideRequiredDriverInputs: boolean;
  @Input() public dateTimeFormat: any;
}


